import { configureStore } from '@reduxjs/toolkit';
import { api } from '@/shared/api';
import { loginReducer } from '@/features/auth';
import { pendingOrdersReducer } from '@/features/orders';
import { regionReducer } from '@/features/region';
import { toastReducer } from './toastSlice';
import { errorMiddleware } from './errorMiddleware';
import { userCacheMiddleware } from './userCacheMiddleware';
import { analyticsMiddleware } from './analyticsMiddleware';

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    login: loginReducer,
    pendingOrders: pendingOrdersReducer,
    region: regionReducer,
    toast: toastReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      api.middleware,
      errorMiddleware,
      userCacheMiddleware,
      analyticsMiddleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
